import * as api from '../api/incomeModels';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_PRICING_SCHEDULES = createRequestTypes(
  'INCOME_MODELS/FETCH_PRICING_SCHEDULES',
);

export const FETCH_PRICING_SCHEDULE = createRequestTypes(
  'INCOME_MODELS/FETCH_PRICING_SCHEDULE',
);

export const INSERT_PRICING_SCHEDULE = createRequestTypes(
  'INCOME_MODELS/INSERT_PRICING_SCHEDULE',
);

export const UPDATE_PRICING_SCHEDULE = createRequestTypes(
  'INCOME_MODELS/UPDATE_PRICING_SCHEDULE',
);

export const UPDATE_PRICING_SCHEDULE_TAGS = createRequestTypes(
  'INCOME_MODELS/UPDATE_PRICING_SCHEDULE_TAGS',
);

export const DELETE_PRICING_SCHEDULE = createRequestTypes(
  'INCOME_MODELS/DELETE_PRICING_SCHEDULE',
);

export const FETCH_CODE_FILE = createRequestTypes(
  'INCOME_MODELS/FETCH_CODE_FILE',
);

export const FETCH_GPR_ADJ_TYPES = createRequestTypes(
  'INCOME_MODELS/FETCH_GPR_ADJ_TYPES',
);

export const FETCH_EXPENSE_TYPES = createRequestTypes(
  'INCOME_MODELS/FETCH_EXPENSE_TYPES',
);

export const DOWNLOAD_PRICING_SCHEDULE_FILE = createRequestTypes(
  'INCOME_MODELS/DOWNLOAD_PRICING_SCHEDULE_FILE',
);

export const INSERT_PRICING_SCHEDULE_FILE = createRequestTypes(
  'INCOME_MODELS/INSERT_PRICING_SCHEDULE_FILE',
);

export const DELETE_PRICING_SCHEDULE_FILE = createRequestTypes(
  'INCOME_MODELS/DELETE_PRICING_SCHEDULE_FILE',
);

export const fetchPricingSchedules = makeApiActionCreatorV3(
  api.fetchPricingSchedules,
  FETCH_PRICING_SCHEDULES[START],
  FETCH_PRICING_SCHEDULES[SUCCESS],
  FETCH_PRICING_SCHEDULES[ERROR],
);

export const fetchPricingSchedule = makeApiActionCreatorV3(
  api.fetchPricingSchedule,
  FETCH_PRICING_SCHEDULE[START],
  FETCH_PRICING_SCHEDULE[SUCCESS],
  FETCH_PRICING_SCHEDULE[ERROR],
);

export const downloadPricingScheduleFile = makeApiActionCreatorV3(
  api.downloadPricingScheduleFile,
  DOWNLOAD_PRICING_SCHEDULE_FILE[START],
  DOWNLOAD_PRICING_SCHEDULE_FILE[SUCCESS],
  DOWNLOAD_PRICING_SCHEDULE_FILE[ERROR],
);

export const insertPricingScheduleFile = makeApiActionCreatorV3(
  api.insertPricingScheduleFile,
  INSERT_PRICING_SCHEDULE_FILE[START],
  INSERT_PRICING_SCHEDULE_FILE[SUCCESS],
  INSERT_PRICING_SCHEDULE_FILE[ERROR],
);

export const deletePricingScheduleFile = makeApiActionCreatorV3(
  api.deletePricingScheduleFile,
  DELETE_PRICING_SCHEDULE_FILE[START],
  DELETE_PRICING_SCHEDULE_FILE[SUCCESS],
  DELETE_PRICING_SCHEDULE_FILE[ERROR],
);

export const deletePricingSchedule = makeApiActionCreatorV3(
  api.deletePricingSchedule,
  DELETE_PRICING_SCHEDULE[START],
  DELETE_PRICING_SCHEDULE[SUCCESS],
  DELETE_PRICING_SCHEDULE[ERROR],
);

export const insertPricingSchedule = makeApiActionCreatorV3(
  api.insertPricingSchedule,
  INSERT_PRICING_SCHEDULE[START],
  INSERT_PRICING_SCHEDULE[SUCCESS],
  INSERT_PRICING_SCHEDULE[ERROR],
);

export const updatePricingSchedule = makeApiActionCreatorV3(
  api.updatePricingSchedule,
  UPDATE_PRICING_SCHEDULE[START],
  UPDATE_PRICING_SCHEDULE[SUCCESS],
  UPDATE_PRICING_SCHEDULE[ERROR],
);

export const updatePricingScheduleTags = makeApiActionCreatorV3(
  api.updatePricingScheduleTags,
  UPDATE_PRICING_SCHEDULE_TAGS[SUCCESS],
  UPDATE_PRICING_SCHEDULE_TAGS[START],
  UPDATE_PRICING_SCHEDULE_TAGS[ERROR],
);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODE_FILE[START],
  FETCH_CODE_FILE[SUCCESS],
  FETCH_CODE_FILE[ERROR],
);

export const fetchGprAdjTypes = makeApiActionCreatorV3(
  api.fetchGprAdjTypes,
  FETCH_GPR_ADJ_TYPES[START],
  FETCH_GPR_ADJ_TYPES[SUCCESS],
  FETCH_GPR_ADJ_TYPES[ERROR],
);

export const fetchExpenseTypes = makeApiActionCreatorV3(
  api.fetchExpenseTypes,
  FETCH_EXPENSE_TYPES[START],
  FETCH_EXPENSE_TYPES[SUCCESS],
  FETCH_EXPENSE_TYPES[ERROR],
);

export const SET_INCOME_MODEL_FILTERS = 'SET_INCOME_MODEL_FILTERS';

export const setIncomeModelFilters = (filters) => ({
  type: SET_INCOME_MODEL_FILTERS,
  payload: filters,
});
